import { useDispatch, useSelector } from 'react-redux';

import { Alert } from '@interstate/components/Alert';
import { Typography } from '@interstate/components/Typography';

import * as vehicleActionCreators from '@makemydeal/dr-dash-store/actions/vehicleActionCreators';
import * as vehicleSelectors from '@makemydeal/dr-dash-store/selectors/vehicleSelectors';
import { formatOfferTypeLabel } from '@makemydeal/dr-shared-ui-utils';

import { CASH_FALLBACK_NOTICE_TEST_ID } from './constants';

export const CashFallbackNotice = () => {
    const dispatch = useDispatch();
    const cashFallbackFromOfferType = useSelector(vehicleSelectors.getCashFallbackFromOfferType);

    if (!cashFallbackFromOfferType) return null;

    const dealType = formatOfferTypeLabel(cashFallbackFromOfferType);

    return (
        <Alert
            type="info"
            role="alert"
            title="Deal moved to Cash"
            data-testid={CASH_FALLBACK_NOTICE_TEST_ID}
            displayCloseButton
            onCloseClick={() => dispatch(vehicleActionCreators.dismissCashFallbackNotice())}
            sx={{ marginBottom: '1rem' }}
        >
            <Typography variant="body-sm" tag="div">
                We couldn’t calculate a {dealType} payment for the selected vehicle, so the deal was moved from {dealType} to Cash
                to keep the vehicle. Adjust the deal first, then change the deal type back to {dealType}.
            </Typography>
        </Alert>
    );
};
